import MDTypography from "components/MDTypography";

import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

import MDBox from "components/MDBox";

function SatisfactionOverview() {
  const test = " ";
  return (
    <MDBox>
      <MDTypography variant="h6" fontWeight="medium">
        Saved QAPIs
      </MDTypography>
    </MDBox>
  );
}

export default SatisfactionOverview;
